import {createContext, useContext} from 'react'

export const GoogleTranslateAPIContext = createContext()
export const GoogleTranslateAPIProvider = GoogleTranslateAPIContext.Provider
export const useGoogleTranslate = () => useContext(GoogleTranslateAPIContext)
